import { risingCardMotion, type FlowThemeCardMotion } from '../../cardMotion';

/** Cards rise in from below with the fleet. */
export const balloonsCardMotion = (isMobile: boolean): FlowThemeCardMotion => risingCardMotion(isMobile, 60, 4);
